import request from '@/utils/request'

const http = request()

export const getFile = ({ fileId, belongId, fileSign }) => http.blob(`/file/${fileId}`, { belongId, fileSign })
